import React from 'react';

import { InputDate } from '@interlayer/js/app/components/common/Fields/InputDate/InputDate';

import { useTranslations } from '@core/js/hooks/i18n';

import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';
import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';

export const DateOfBirthField: React.FC<{ placeholder?: string }> = ({ placeholder }) => {
    const t = useTranslations('playtech.mobile.system.registration.');
    const { config: { showSuccessTickIcons } } = useRegistrationSelector();

    return (
        <InputDate
            name={VALIDATION_FIELDS.dateOfBirth}
            isShowValidationIcon={showSuccessTickIcons}
            placeholder={placeholder || t('label.date')}
        />
    );
};
